var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { makeObservable } from 'mobx';
import { sortedSet } from '../../../../utils/mobx/decorators/customComputed';
import { ChannelName } from '../../../learnware/LearnwareEnums';
import { ChannelInfo } from './modules/ChannelInfo';
import { memoize } from '../../../../utils/mobx/decorators/memoize';
import { ChannelIntents } from './modules/ChannelIntents';
export class MediaChannel {
    parent;
    channelName = ChannelName.Voice;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get channels() {
        return this.parent;
    }
    get mediaPlayer() {
        return this.channels.mediaPlayer;
    }
    get intents() {
        return this.channels.intents.filter(intent => intent.intentSettings.playbackChannel === this.channelName);
    }
    get intentsByState() {
        return new ChannelIntents(this);
    }
    get channelInfo() {
        return new ChannelInfo(this);
    }
}
__decorate([
    sortedSet
], MediaChannel.prototype, "intents", null);
__decorate([
    memoize
], MediaChannel.prototype, "intentsByState", null);
__decorate([
    memoize
], MediaChannel.prototype, "channelInfo", null);
